module.exports = __webpack_public_path__ + "8xiangcunzhili";